module.exports = __webpack_public_path__ + "img/E-WEB-Goal-15.d0eff7a9.svg";